<sb-card>
  <div card-header classes="no-border">
    <h3>Impressions</h3>
  </div>
  <div card-fit classes="overflow-hidden">
    <img style="width: 100%;" src="./assets/img/shell-inside.png"/>
  </div>
</sb-card>

